<template>
    <q-layout view="hHr lpr fFr">
        <q-header elevated class="bg-orange-6 text-indigo-9 noprint">
            <q-toolbar>
                <!-- q-btn dense flat round icon="menu" @click="left = !left" / -->

                <q-toolbar-title>
                    <q-avatar class="bg-white">
                    <img src="../assets/djembefolla_petit.png">
                    </q-avatar>
                    Djembé!
                </q-toolbar-title>

                <q-tabs align="left" v-if="$route.path!=='/writesyntaxhelp'">
                    <!-- q-route-tab to="/compositeur" label="Compositeur" / -->
                    <q-route-tab to="/partitions" label="Partitions" />
                    <!-- q-route-tab to="/help" label="Aide" / -->
                    <q-route-tab to="/about" label="A Propos" />
                </q-tabs>
                
                <!-- q-btn dense outline rounded flat icon="school" @click="setCustomClaim" / -->

                <q-btn v-if="$route.path!=='/writesyntaxhelp'" dense outline rounded flat icon="person" @click="user_panel = !user_panel" 
                    :label="(user) ? user.firstname : 'Invité'" :class="{ 'i-am-admin':isAdmin }">
                    <q-tooltip>
                        Panneau de connexion
                    </q-tooltip>
                </q-btn>
            </q-toolbar>
        </q-header>

        <!-- drawer content -->
        <q-drawer v-if="$route.path!=='/writesyntaxhelp'" v-model="left" side="left" overlay bordered class="bg-positive noprint">
        </q-drawer>

        <!-- user authentication -->
        <q-drawer v-if="$route.path!=='/writesyntaxhelp'" v-model="user_panel" side="right" bordered class="noprint">
            <div v-if="user"><!-- ========== user is connected ========== -->
                <q-list bordered>
                    <q-item class="text-justify">
                        <q-btn dense outline rounded class="full-width" icon="person" color="primary" @click="onSignout" label="Déconnexion" />
                    </q-item>

                    <q-expansion-item
                        class="shadow-1 overflow-hidden q-ma-sm" style="border-radius: .5em" label="Mon profil" group="" 
                        header-class="bg-primary text-white" expand-icon-class="text-white" dense default-opened ><!-- mon profil -->
                        <q-card>
                            <q-card-section>
                                <q-form @submit="onUpdateUserProfile" class="q-gutter-xs text-center q-pa-xs" >
                                    <q-input filled v-model="temp_login_data.firstname" label="Prénom" dense 
                                        lazy-rules :rules="[ val => val && val.length > 0 || 'Entrez votre prénom']"
                                    />
                                    <q-input filled v-model="temp_login_data.lastname" label="Nom" dense
                                        lazy-rules :rules="[ val => val && val.length > 0 || 'Entrez votre nom']"
                                    />
                                    <q-btn dense outline rounded class="full-width" label="SAUVER" type="submit" color="primary" />
                                </q-form>
                                <q-expansion-item
                                    class="shadow-1 overflow-hidden q-mt-sm" style="border-radius: .5em" label="Changer d'adresse email" group="" 
                                    header-class="bg-primary text-white" expand-icon-class="text-white" dense ><!-- changer d'adrese email -->
                                    <q-form @submit="onChangeUserEmail" class="q-gutter-xs text-center q-pa-xs" >
                                        Changer d'adresse email implique que votre identifiant de connexion change aussi.
                                        <q-input filled v-model="temp_login_data.email" label="Adresse email" dense
                                            lazy-rules :rules="[ val => val && val.length > 0 && val.match(/.{2,}@.{2,}\..{2,}/) || 'Entrez une adresse valide']"
                                        />
                                        <q-btn dense outline rounded class="full-width" label="SAUVER" type="submit" color="primary" />
                                    </q-form>
                                </q-expansion-item>
                                <q-expansion-item
                                    class="shadow-1 overflow-hidden q-mt-sm" style="border-radius: .5em" label="Changer le mot de passe" group="" 
                                    header-class="bg-primary text-white" expand-icon-class="text-white" dense ><!-- changer de mot de passe -->
                                    <q-form @submit="onChangeUserPassword" class="q-gutter-xs text-center q-pa-xs" >
                                        <q-input filled v-model="temp_login_data.password" dense
                                            :type="temp_login_data.isPwd1 ? 'password' : 'text'"
                                            label="Nouveau mot de passe" 
                                            lazy-rules :rules="[ val => val && val.length > 7 || '8 caractères minimum',
                                                                val => val.match(/[A-Z]/) || 'Au moins une majuscule',
                                                                val => val.match(/[a-z]/) || 'Au moins une minuscule',
                                                                val => val.match(/[0-9]/) || 'Au moins un chiffre',
                                                            ]"
                                        >
                                            <template v-slot:append>
                                                <q-icon
                                                    :name="temp_login_data.isPwd1 ? 'visibility_off' : 'visibility'"
                                                    class="cursor-pointer"
                                                    @click="temp_login_data.isPwd1 = !temp_login_data.isPwd1"
                                                />
                                            </template>
                                        </q-input>
                                        <q-input filled v-model="temp_login_data.password2" dense
                                            :type="temp_login_data.isPwd1 ? 'password' : 'text'"
                                            label="Répéter le mot de passe" 
                                            lazy-rules :rules="[ val => val && val == temp_login_data.password || 'Veuillez entrer le même mot de passe' ]"
                                        >
                                            <template v-slot:append>
                                                <q-icon
                                                    :name="temp_login_data.isPwd1 ? 'visibility_off' : 'visibility'"
                                                    class="cursor-pointer"
                                                    @click="temp_login_data.isPwd1 = !temp_login_data.isPwd1"
                                                />
                                            </template>
                                        </q-input>

                                        <q-btn dense outline rounded class="full-width" label="SAUVER" type="submit" color="primary" />
                                    </q-form>
                                </q-expansion-item>
                                <q-expansion-item
                                    class="shadow-1 overflow-hidden q-mt-sm" style="border-radius: .5em" label="Supprimer mon compte" group="" 
                                    header-class="bg-primary text-white" expand-icon-class="text-white" dense ><!-- se désabonner -->
                                    <div class="q-pa-xs">
                                        <p class="text-negative text-bold text-center">
                                            ATTENTION!<br />SE DESABONNER EST IRREVOCABLE!
                                        </p>
                                        <p>
                                            En cliquant sur le bouton ci-dessous, vous comprenez que votre compte utilisateur sera 
                                            annulé, et que vous perdrez automatiquement vos droit d'édition sur tous les titres dont 
                                            vous êtes le propriétaire actuel. Vous aurez cependant la liberté de re-créer un nouveau
                                            compte si vous le désirez.
                                        </p>
                                        <q-btn dense outline rounded class="full-width" color="negative" @click="onUnsubscribe" label="Me désabonner" />
                                    </div>
                                </q-expansion-item>
                            </q-card-section>
                        </q-card>
                    </q-expansion-item>

                    <q-separator />

                </q-list>
            </div>
            <div v-else><!-- user is not connected -->
                <q-list bordered>
                    <!-- login -->
                    <q-expansion-item
                        class="shadow-1 overflow-hidden q-ma-sm" style="border-radius: 30px" label="Connexion" group="login_group" 
                        header-class="bg-primary text-white" expand-icon-class="text-white" dense default-opened >
                        <q-card>
                            <q-card-section>
                                <q-form @submit="onSignin" class="q-gutter-md text-center" >
                                    <q-input filled v-model="temp_login_data.email" label="Adresse email" />
                                    <q-input filled v-model="temp_login_data.password" 
                                        :type="temp_login_data.isPwd1 ? 'password' : 'text'"
                                        label="Mot de passe" >
                                        <template v-slot:append>
                                            <q-icon
                                                :name="temp_login_data.isPwd1 ? 'visibility_off' : 'visibility'"
                                                class="cursor-pointer"
                                                @click="temp_login_data.isPwd1 = !temp_login_data.isPwd1"
                                            />
                                        </template>
                                    </q-input>

                                    <q-checkbox v-model="temp_login_data.rememberme" label="Se souvenir de moi" />

                                    <br />
                                    <a href="#" @click.prevent="forgotMyPassword">J'ai oublié mon mot de passe</a>

                                    <div>
                                        <q-btn dense outline rounded class="full-width" label="Connexion" type="submit" color="primary"/>
                                    </div>
                                </q-form>

                            </q-card-section>
                        </q-card>
                    </q-expansion-item>
                    
                    <!-- sign up  -->
                    <q-expansion-item
                        class="shadow-1 overflow-hidden q-ma-sm" style="border-radius: 30px" label="Créer un compte" group="login_group" 
                        header-class="bg-primary text-white" expand-icon-class="text-white" dense default-opened >
                        <q-card>
                            <q-card-section>
                                <q-form @submit="onSignup" class="q-gutter-md text-center" >
                                    <q-input filled v-model="temp_login_data.email" label="Adresse email" 
                                        lazy-rules :rules="[ val => val && val.length > 0 && val.match(/.{2,}@.{2,}\..{2,}/) || 'Entrez une adresse valide']"
                                    />
                                    
                                    <q-input filled v-model="temp_login_data.firstname" label="Prénom" 
                                        lazy-rules :rules="[ val => val && val.length > 0 || 'Entrez votre prénom']"
                                    />
                                    <q-input filled v-model="temp_login_data.lastname" label="Nom" 
                                        lazy-rules :rules="[ val => val && val.length > 0 || 'Entrez votre nom']"
                                    />

                                    <q-input filled v-model="temp_login_data.password" 
                                        :type="temp_login_data.isPwd1 ? 'password' : 'text'"
                                        label="Mot de passe" 
                                        lazy-rules :rules="[ val => val && val.length > 7 || '8 caractères minimum',
                                                             val => val.match(/[A-Z]/) || 'Au moins une majuscule',
                                                             val => val.match(/[a-z]/) || 'Au moins une minuscule',
                                                             val => val.match(/[0-9]/) || 'Au moins un chiffre',
                                                           ]"
                                    >
                                        <template v-slot:append>
                                            <q-icon
                                                :name="temp_login_data.isPwd1 ? 'visibility_off' : 'visibility'"
                                                class="cursor-pointer"
                                                @click="temp_login_data.isPwd1 = !temp_login_data.isPwd1"
                                            />
                                        </template>
                                    </q-input>
                                    <q-input filled v-model="temp_login_data.password2" 
                                        :type="temp_login_data.isPwd1 ? 'password' : 'text'"
                                        label="Répéter le mot de passe" 
                                        lazy-rules :rules="[ val => val && val == temp_login_data.password || 'Veuillez entrer le même mot de passe' ]"
                                    >
                                        <template v-slot:append>
                                            <q-icon
                                                :name="temp_login_data.isPwd1 ? 'visibility_off' : 'visibility'"
                                                class="cursor-pointer"
                                                @click="temp_login_data.isPwd1 = !temp_login_data.isPwd1"
                                            />
                                        </template>
                                    </q-input>
                                    
                                    <q-expansion-item label="Conditions d'utilisation" header-class="text-primary" class="text-justify">
                                        <p class="text-justify">
                                            Le fait de s'enregistrer sur ce site présuppose l'acceptation des points suivants:
                                            <ol>
                                                <li>La création d'un compte est entièrement gratuite.</li>
                                                <li>
                                                    Des informations personnelles (prénom, nom et adresse email) sont conservées aux fins d'identification.
                                                    <br />
                                                    En aucun cas ces informations ne seront données, vendues ou échangées à des tiers.
                                                    <br />
                                                    Les mots de passe sont encryptés avant d'être stockés dans la base de données.
                                                    <br />
                                                    La résiliation du compte entraine une suppression complète de ces données.
                                                    <br />
                                                    La résiliation du compte entraine aussi la perte des prérogative d'auteur, à savoir, l'impossibilité de 
                                                    modifier ou supprimer toute partition créée au préalable avec le-dit compte.
                                                </li>
                                                <li>Tout comportement abusif peut se voir sanctionné par une suppression pure et simple du compte incriminé. 
                                                    Par comportement abusif, il faut inclure les insultes et les grossièretés, la production de partitions fauses 
                                                    de manière délibérée, ainsi que tout refus de prendre en compte les remarques et avertissements du gestionnaire de site.</li>
                                                <li>Le contenu de ce site est essentiellement fourni par ses utilisateurs ; les administrateurs du système ne peuvent en aucun être 
                                                    tenus responsable d'erreurs dans la rédaction ou le contenu des partitions.
                                                </li>
                                                <li>Le rédacteur s'engage à ne publier que des titres dont il est soit lui-même l'auteur, soit que le
                                                    titre en question fait partie du domaine publique ou est publiable.
                                                </li>
                                                <li>Aucun profit ne peut être dégagé de l'utilisation de ce site par ses membres.</li>
                                            </ol>
                                        </p>
                                    </q-expansion-item>
                                    <q-checkbox v-model="conditions_d_utilisation" label="J'accepte les conditions d'utilisation" class="q-mr-sm" 
                                        lazy-rules :rules="[ val => val.checked]" />
                                    <!-- TODO:  captcha : je ne suis pas un robot -->
                                    <div>
                                        <q-btn dense outline rounded class="full-width" label="CREER MON COMPTE" type="submit" color="primary" />
                                    </div>
                                </q-form>
                            </q-card-section>
                        </q-card>
                    </q-expansion-item>

                    <!-- surf as guest -->
                    <q-expansion-item
                        class="shadow-1 overflow-hidden q-ma-sm" style="border-radius: 30px" label="Naviguer comme invité" group="login_group" 
                        header-class="bg-primary text-white" expand-icon-class="text-white" dense default-opened >
                        <q-card>
                            <q-card-section class="text-justify">
                                <p>
                                    Il n'est pas nécéssaire de créer un compte ou de m'identifier pour naviguer sur ce site. Cependant, ce site
                                    ne sera accessible qu'en lecture seulement : sans identification, il n'est pas possible de sauver ses 
                                    propres compositions.
                                </p>
                                <p>
                                    Les partitions sont proposées à titre indicatif ; la direction du site n'assume aucune responsabilité en cas d'inexactitude.
                                </p>
                            </q-card-section>
                        </q-card>
                    </q-expansion-item>
                </q-list>
            </div>
            <!-- USER preferences -->
            <q-expansion-item group="" label="Mes préférences" header-class="text-primary">
                <q-card>
                    <q-card-section>
                        <q-slider
                            v-model="bpm"
                            :min="40"
                            :max="140"
                            :step="10"
                            snap
                            label
                            :label-value="bpm + ' BPM'"
                            label-always
                            color="primary"
                        />
                    </q-card-section>
                    <q-card-section>
                        Jouer l'appel:
                    </q-card-section>
                    <q-card-section>
                        <q-radio v-model="appel" val="" label="Non" />
                        <q-radio v-model="appel" val="wt.tt.t.tt.sss..." label="Binaire" />
                        <q-radio v-model="appel" val="wt.tt.tt.tt.." label="Ternaire" />
                    </q-card-section>
                </q-card>
            </q-expansion-item>
        </q-drawer>

        <q-page-container class="print-full-width print-div">
            <q-page style="height:150px;">
                <router-view :currentuser="user"/>
            </q-page>
        </q-page-container>

    </q-layout>
</template>

<script>
import firebase from '../firebase.js';
import { Notify } from 'quasar'
import Rythme from '../components/Rythme.vue';

export default {
    data () {
        return {
            left: false,
            user_panel: false,
            user: null,
            userlist: {},
            conditions_d_utilisation: false,
            temp_login_data : { 
                password: null,
                isPwd1: true,
                password2: null,
                firstname: null,
                lastname: null,
                email: null,
                rememberme: true,
            },
        }
    },
    computed: {
        isAdmin(){
            if (this.user){
                return this.user.admin;
            }
            else{
                return false;
            }
        },
        bpm: {
            get () { return this.$store.state.bpm },
            set (value) { this.$store.commit('setBpm', value) }
        },
        appel: {
            get () { return this.$store.state.appel },
            set (value) { this.$store.commit('setAppel', value) }
        },
    },
    methods: {
        /* setCustomClaim(){}, */
        getUserDetails(email){
            let self = this;
            if (email){
                firebase.firestore().collection("users")
                    .doc(email)
                    .get()
                    .then(function(user) {
                        // console.log("user", user);
                        // Notify.create({ message: "Sauvegarde réussie.", color: 'primary' });
                        self.user = {
                            email    : user.data()['email'],
                            firstname: user.data()['fname'],
                            lastname : user.data()['lname'],
                            admin    : user.data()['isadmin'],
                        };
                        self.temp_login_data.firstname  = self.user.firstname;
                        self.temp_login_data.lastname   = self.user.lastname;
                        self.temp_login_data.email      = self.user.email;
                        self.temp_login_data.rememberme = true;
                    })
                    .catch(function(error) {
                        Notify.create({ message: "ERREUR: profil utilisateur non trouvé.", color: 'negative', timeout: 0 });
                        console.error("Error writing document: ", error);
                    });
            }
        },
        onSignin(){
            let self = this;
            // send the login request to firebase
            self.temp_login_data.email = self.temp_login_data.email.toLowerCase();
            let persistance = firebase.auth.Auth.Persistence.LOCAL;
            if (!self.temp_login_data.rememberme){ // don't remember me
                persistance = firebase.auth.Auth.Persistence.SESSION;
            }

            firebase.auth().setPersistence(persistance)
            .then(function() {
                return firebase.auth().signInWithEmailAndPassword(self.temp_login_data.email, self.temp_login_data.password)
                    .then(
                        (user) => {
                            // console.log("logged in user;", user);
                            self.getUserDetails(user.email);
                            self.user_panel = false;
                            self.temp_login_data.password = "";
                        },
                        function(err){
                            alert('Oops! ' + err.message);
                            console.log("signIn error", err);
                        }
                    );
            })
            .catch(function(error) {
                // Handle Errors here.
                var errorCode = error.code;
                var errorMessage = error.message;
            });

        },
        onSignup(){
            let self = this;
            if (!this.conditions_d_utilisation){
                Notify.create({ message: "Vous devez accepter les conditions d'utilisation pour vous enregistrer.", color: 'negative', timeout: 0 });
                return;
            }
            self.temp_login_data.email = self.temp_login_data.email.toLowerCase();
            firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL)
            .then(function() {
                // Notify.create({ message: "signUp() fired!", color: 'positive', timeout: 0 });
                firebase.auth().createUserWithEmailAndPassword(self.temp_login_data.email, self.temp_login_data.password).then(
                    function(user){
                        self.user = {
                            email: self.temp_login_data.email,
                            firstname: self.temp_login_data.firstname,
                            lastname: self.temp_login_data.lastname,
                            admin: false
                        };
                        // create this user in the 'users' table
                        firebase.firestore().collection("users").doc(self.user.email)
                            .set({
                                email  : self.user.email,
                                fname  : self.user.firstname,
                                lname  : self.user.lastname,
                                isadmin: false
                            })
                            .then(function() {
                                // Notify.create({ message: "Sauvegarde réussie.", color: 'primary' });
                                self.temp_login_data ={
                                    email: '',
                                    firstname: '',
                                    lastname: '',
                                    admin: false
                                };
                            })
                            .catch(function(error) {
                                Notify.create({ message: "Problème rencontré lors de la création du profil utilisateur.", color: 'negative', timeout: 0 });
                                console.error("Error writing document: ", error);
                            });
                        Notify.create({ message: "L'enregistrement a réussi : félicitations!", color: 'positive', timeout: 0 });
                    },
                    function(err){ // login failed
                        Notify.create({ message: "L'enregistrement a échoué: "+err.message, color: 'negative', timeout: 0 });
                        console.log('Oops. ' + err);
                    }
                );
            })
            .catch(function(error) {
                // Handle Errors here.
                var errorCode = error.code;
                var errorMessage = error.message;
            });
        },
        onSignout(){
            let self = this;
            firebase.auth().signOut().then(
                function(){
                    self.user = null;
                    // self.getSongList();
                    Notify.create({ message: "Vous êtes déconnecté.", color: 'positive' });
                },
                function(err){
                    alert("ERROR: open the console for details");
                    console.log("ERR", err);
                }
            );
        },
        forgotMyPassword(){
            // send a password reset email
            var emailAddress = this.temp_login_data.email;
            if (!emailAddress.match(/.{2,}@.{2,}\..{2,}/)){
                Notify.create({ message: "ERREUR: vous devez spécifier un adresse email valide pour pouvoir vous envoyer un lien de réinitialisation.", color: 'negative', timeout: 0 });
                return;
            }
            var auth = firebase.auth();
            auth.sendPasswordResetEmail(emailAddress)
            .then(function() { // Email sent.
                Notify.create({ message: "Un email de réinitialisation de mot de passe a été envoyé à l'adresse indiquée.", color: 'primary' });
            })
            .catch(function(error) { // An error happened.
                Notify.create({ message: "ERREUR: "+error.message, color: 'negative', timeout: 0 });
            });
        },
        reAffectSongs(source, target){ // all songs owned by [source] must changed and affected to [target]
            const self = this;
            // read all songs first
            const db = firebase.firestore();
            db.collection("songs").where("author", "==", source).get().then(
                (values) => {
                    // console.log("values", values);
                    // Get a new write batch
                    var batch = db.batch();

                    values.docs.forEach((song) => {
                        // console.log("song.id", song.id);
                        batch.update(db.collection("songs").doc(song.id), {author: target});
                    });

                    // Commit the batch
                    batch.commit()
                    .then(function () {
                        // Notify.create({ message: "Réaffectation de vos compositions vers '"+target+"'.", color: 'positive', timeout: 0 });
                    })
                    .catch((err) => {
                        Notify.create({ message: "ERREUR: une erreur interne a fait que vos compositions n'ont pas pu être réassignées.", color: 'negative', timeout: 0 });
                        console.log("reAffectSongs() - ERROR", err);
                    });
                }
            )
            .catch((err) => {
                console.log("reAffectSongs() - Error loading the song list.", err);
                Notify.create({ message: "ERREUR: impossible de ré-assigner vos compositions.", color: 'negative', timeout: 0 });
            });
        },
        onUnsubscribe(){
            const self = this;
            const user = firebase.auth().currentUser;
            // console.log("user", user);
            const user_email = user.email;
            user.delete()
                .then(function() {
                    // User deleted in the auth system, now remove the user profile
                    firebase.firestore().collection("users").doc(self.user.email)
                        .delete()
                        .then(
                            () => { 
                                Notify.create({ message: "Votre compte a bien été supprimé. Revenez quand vous voudrez.", color: 'positive', timeout:0 });
                            }
                        )
                        .catch(
                            (err) => {
                                Notify.create({ message: "ERREUR: une erreur interne a fait que votre compte n'a pas pu être supprimé. Merci de prendre contact par email avec l'administrateur à l'adresse pierre@pierrevn.be en expliquant le problème. Merci de votre compréhension.", color: 'positive', timeout: 0 });
                                console.log("ERROR", err);
                            }
                        )
                    self.onSignout();
                    // re-affect all song owned by the ex-user to 'admin'
                    self.reAffectSongs(user_email, 'pierre@pierrevn.be');
                })
                .catch(function(error) {
                    // An error happened.
                    console.log("Error removing your account", error);
                });
        },
        onUpdateUserProfile(){
            const self = this;
            const user = firebase.auth().currentUser;
            if (user){
                const user_email = user.email;
                var user_def = firebase.firestore().collection("users").doc(user_email);

                // Set the "capital" field of the city 'DC'
                return user_def.update({
                    fname: self.temp_login_data.firstname,
                    lname: self.temp_login_data.lastname
                })
                .then(function() {
                    Notify.create({ message: "Les nouvelles données ont été sauvées.", color: 'positive' });
                    self.user.firstname = self.temp_login_data.firstname;
                    self.user.lastname = self.temp_login_data.lastname;
                })
                .catch(function(error) {
                    // The document probably doesn't exist.
                    console.error("onUpdateUserProfile() - Error saving profile update: ", error);
                    Notify.create({ message: "Une erreur est apparue lors de la sauvegarde de vos données. Si le problème persiste, veuillez prévenir l'administrateur à l'adresse pierre@pierrevn.be. Merci de votre compréhension.", color: 'negative', timeout:0 });
                });
            }
        },
        onChangeUserPassword(){
            const self = this;
            var user = firebase.auth().currentUser;
            user.updatePassword(self.temp_login_data.password).then(function() {
                Notify.create({ message: "Votre nouveau mot de passe a été modifié.", color: 'positive' });
            }).catch(function(error) {
                Notify.create({ message: "Erreur lors de la sauvegarde de votre nouveau mot de passe. Si le problème persiste, veuillez prendre contact avec l'administrateur du sytème à l'adresse email pierre@pierrevn.be. Merci de votre compréhension.", color: 'negative', timeout: 0 });
            });

        },
        onChangeUserEmail(){
            const self = this;
            var user = firebase.auth().currentUser;
            const user_email = user.email;
            user.updateEmail(self.temp_login_data.email).then(function() {
                // Update successful.
                Notify.create({ message: "Votre nouvelle adresse email a été sauvée. Vous devez maintenant vous reconnecter avec la nouvelle adresse.", color: 'positive' });
                // save the new email address in collection('users') => delete the old one, create the new one
                firebase.firestore().collection("users").doc(self.temp_login_data.email)
                    .set({
                        email  : self.temp_login_data.email,
                        fname  : self.user.firstname,
                        lname  : self.user.lastname,
                        isadmin: self.user.admin
                    })
                    .then(function() {
                        // Notify.create({ message: "Sauvegarde réussie.", color: 'primary' });
                        self.temp_login_data = {
                            email: '',
                            firstname: '',
                            lastname: '',
                            password: null,
                            isPwd1: true,
                            password2: null,
                            admin: false
                        };
                        // now remove the old users profile
                        firebase.firestore().collection("users").doc(user_email)
                            .delete()
                            .then(
                                () => { 
                                    // Notify.create({ message: "Votre compte a bien été supprimé. Revenez quand vous voudrez.", color: 'positive' });
                                }
                            )
                            .catch(
                                (err) => {
                                    Notify.create({ message: "ERREUR: une erreur interne a fait que votre compte n'a pas pu être supprimé. Merci de prendre contact par email avec l'administrateur à l'adresse pierre@pierrevn.be en expliquant le problème. Merci de votre compréhension.", color: 'positive', timeout: 0 });
                                    console.log("ERROR", err);
                                }
                            )
                    })
                    .catch(function(error) {
                        Notify.create({ message: "Problème rencontré lors de la mise à jour du profil utilisateur.", color: 'negative', timeout: 0 });
                        console.error("onChangeUserEmail() - Error updating user profile: ", error);
                    });
                // re-assign all songs to the new email address
                self.reAffectSongs(user_email, self.temp_login_data.email);
                // self.onSignout();
            }).catch(function(error) {
                // An error happened.
                Notify.create({ message: "Erreur lors de la sauvegarde de votre nouvelle adresse email. Si le problème persiste, veuillez prendre contact avec l'administrateur du sytème à l'adresse email pierre@pierrevn.be. Merci de votre compréhension.", color: 'negative', timeout: 0 });
            });

        },
    },
    mounted: function(){
        let self = this;
        // console.log("process.env", process.env);
        // console.log("user initial state:", firebase.auth().currentUser);
        firebase.auth().onAuthStateChanged(async user => {
            // console.log("user state changed:", firebase.auth().currentUser);
            if (user){
                // console.log("user is logged in!");
                self.getUserDetails(firebase.auth().currentUser.email);
            }
        });
    }
}
</script>

<style>
#app {
    max-height:100vh;
    overflow: hidden;
}
.q-page-container {
}
.print-full-width {
    margin-top: 50px !important;
    padding-top: 0 !important;
}
@font-face {
    font-family: djembe;
    src: url(../assets/fonts/Djembe.ttf);
}
.p-music {
    font-family: djembe;
    font-size  : 2em;
    white-space: normal;
    position   : relative;
    top        : -.5em;
}
.light-gray {
    color:#aaa;
}
.print-div {
    overflow-y: scroll;
}
.i-am-admin {
    color: red !important;
}
@media print{
    .noprint {
        display: none;
    }
    .print-full-width {
        width: 100vw;
        position: absolute;
        margin-top: 0;
        top: 0;
        left: 0;
        white-space: normal;
    }
    .print-div {
        overflow:auto;
    }
}

td.underlined {
    border-bottom: 1px solid #bbb;
}
</style>